import { z } from 'zod';

export const configureAddOnsSchema = (serviceCount: number) =>
    z
        .object({
            addOnDate: z.date().nullable().optional(),
            linkedServiceId: z
                .string({ required_error: 'Schedule type is required' })
                .min(1, 'Schedule type is required'),
        })
        .superRefine((data, ctx) => {
            if (data.linkedServiceId === 'eachservice' && serviceCount === 0) {
                ctx.addIssue({
                    path: ['linkedServiceId'],
                    code: z.ZodIssueCode.custom,
                    message: "Add a service first to use 'With each service'",
                });
            }

            if (data.linkedServiceId === 'independent') {
                const yesterday = new Date();
                yesterday.setDate(yesterday.getDate() - 1);

                if (!data.addOnDate) {
                    ctx.addIssue({
                        path: ['addOnDate'],
                        code: z.ZodIssueCode.custom,
                        fatal: true,
                        message: 'The scheduled optional extra date is required',
                    });
                }
                if (data.addOnDate && data.addOnDate < yesterday) {
                    ctx.addIssue({
                        path: ['addOnDate'],
                        code: z.ZodIssueCode.too_small,
                        type: 'date',
                        inclusive: true,
                        minimum: 1,
                        message: "The scheduled optional extra date can't be in the past",
                    });
                }
            }
        });

export type ConfigureAddOnsFormData = z.infer<ReturnType<typeof configureAddOnsSchema>>;
